import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Heading from '../Heading'

class SubSectionHeading extends Component {
  render () {
    return (
      <Heading headingLevel={3} styleLevel={1}>{ this.props.children }</Heading>
    )
  }
}

SubSectionHeading.propTypes = {
  children: PropTypes.node.isRequired
}

export default SubSectionHeading



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/SubSectionHeading/index.js